
// if(window.location.href.includes('https://animeal.in/pages/pet-information')){
//  https://nodejs.animeal.in/api/get-pet?customer_id=${ customerId }
//  https://nodejs.animeal.in/api/update-pet-profile?customer_id=${customerId}&pet_numb=${petId}

let allFormsQty = 0;


let selectedMedicalConditions = [];
let selectedAllergies = [];
let selectedFlavours = [];
let selectedToys = [];
let presentPetData = {
  petexist0: {
    selectedMedicalConditions: [],
    selectedAllergies: [],
    selectedFlavours: [],
    selectedToys: []
  }
};
let customerId;

let presenPetIndex = 1;

const petBackBtn = document.querySelector('.pet-btn-container .pet-back-btn');
const petNextBtn = document.querySelector('.pet-btn-container .pet-next-btn');
const petSubmitBtn = document.querySelector('.pet-btn-container .pet-submit-btn');
const petDetailsContainer = document.querySelectorAll('.pet-details-container');
const petBannerImageContainer = document.querySelectorAll('.pet-banner-img');
const petBannerMsg = document.querySelectorAll('.pet-msg-banner');
const petSelectorContainer = document.querySelector('.pet-selector');
const petPopupOverlay = document.querySelector('.pet-popup-msg-overlay');
const petPopupMsg = document.querySelector('.pet-popup-msg-container');

// ✅ Shows inline errors and returns validation status
const checkRequiredFields = (step) => {
  const stepContainer = petDetailsContainer[step - 1];
  const emptyFields = [];

  // Clear existing field errors
  stepContainer.querySelectorAll('.field-error').forEach(el => el.remove());

  // 1. Text, date, etc.
  const requiredInputs = stepContainer.querySelectorAll('input[required]:not([type="radio"])');
  requiredInputs.forEach(field => {
    if (!field.value.trim()) {
      emptyFields.push(`Field ${field.name || field.id}`);
      showFieldError(field, 'This field is required.');
    }
  });

  // 2. Radio groups
  const radioGroups = new Set();
  const radioInputs = stepContainer.querySelectorAll('input[type="radio"][required]');
  radioInputs.forEach(radio => radioGroups.add(radio.name));

  radioGroups.forEach(name => {
    const group = stepContainer.querySelectorAll(`input[name="${name}"]`);
    const isChecked = stepContainer.querySelector(`input[name="${name}"]:checked`);
    if (!isChecked && group.length > 0) {
      emptyFields.push(`Radio group ${name}`);
      showFieldError(group[group.length - 1].parentElement, 'Please select an option.');
    }
  });

  // 3. Custom check for step 3
  if (presenPetIndex === 3) {
    const petData = presentPetData.petexist0;
    if (petData.selectedMedicalConditions.length === 0) {
      emptyFields.push("Medical conditions, flavours, or toys selection");
      const medicalSection = stepContainer.querySelector('.medical-conditions-wrapper');
      if (medicalSection) {
        showFieldError(medicalSection, 'Please select at least one option.');
      }
    }
  }

  if (emptyFields.length > 0) {
    showErrorMessage();
    return false;
  } else {
    hideErrorMessage();
    return true;
  }
};

// ✅ Show inline error message below field
const showFieldError = (element, message) => {
  const error = document.createElement('div');
  error.className = 'field-error';
  error.style.color = 'red';
  error.style.fontSize = '0.85em';
  error.style.marginTop = '4px';
  error.style.width = '100%'
  error.textContent = message;

  // Insert error after field or field container
  if (element?.parentNode) {
    element.insertAdjacentElement('afterend', error);
  }
};

// ✅ General banner message
const showErrorMessage = () => {
  const msgContainer = document.querySelector('.pet-msg-container');
  const msgText = document.querySelector('.pet-msg');
  msgText.innerHTML = "Please fill all required fields to move further.";
  msgContainer.style.display = 'block';
};

const hideErrorMessage = () => {
  document.querySelector('.pet-msg-container').style.display = 'none';
};

// ✅ Control button visibility
const managePetBtn = () => {
  if (presenPetIndex === 1) {
    petBackBtn && (petBackBtn.style.display = 'none');
    petNextBtn && (petNextBtn.style.display = 'block');
    petSubmitBtn && (petSubmitBtn.style.display = 'none');
    petSelectorContainer && (petSelectorContainer.style.opacity = 1);
  } else if (presenPetIndex === 4) {
    petBackBtn && (petBackBtn.style.display = 'block');
    petNextBtn && (petNextBtn.style.display = 'none');
    petSubmitBtn && (petSubmitBtn.style.display = 'block');
    petSelectorContainer && (petSelectorContainer.style.opacity = 0);
  } else {
    petBackBtn && (petBackBtn.style.display = 'block');
    petNextBtn && (petNextBtn.style.display = 'block');
    petSubmitBtn && (petSubmitBtn.style.display = 'none');
    petSelectorContainer && (petSelectorContainer.style.opacity = 0);
  }
};

// ✅ Show/hide containers per step
const showHidePetContainers = () => {
  petDetailsContainer.forEach((petDetails, index) => {
    const isActive = petDetails.classList.contains(`pet-details-${presenPetIndex}`);
    petDetails.style.display = isActive ? 'block' : 'none';
    petBannerImageContainer[index].style.display = isActive ? 'block' : 'none';
    petBannerMsg[index].style.display = isActive ? 'block' : 'none';
  });
};

// ✅ Back button click
petBackBtn?.addEventListener('click', () => {
  if (presenPetIndex > 1) {
    presenPetIndex--;
    managePetBtn();
    showHidePetContainers();
    hideErrorMessage();
  }
});

// ✅ Next button click — validate, then proceed
petNextBtn?.addEventListener('click', () => {
  const valid = checkRequiredFields(presenPetIndex);
  if (valid) {
    presenPetIndex++;
    managePetBtn();
    showHidePetContainers();
    hideErrorMessage();
  }
});

// ✅ Submit button click — optional, add similar check if needed
petSubmitBtn?.addEventListener('click', () => {
  const valid = checkRequiredFields(presenPetIndex);
  if (!valid) {
    // Block form submission or show errors
    return;
  }
  // Submit logic goes here...
});

// ✅ Initial UI setup
managePetBtn();
showHidePetContainers();



document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.already-present .suggestion-item').forEach(item => {
    const checkbox = item.querySelector('input');
    const pTag = item.querySelector('p');

    checkbox.addEventListener('change', () => {
      addsuggestedValues(checkbox.value, 'medical', 0, checkbox.checked, item.closest('.already-present'));
      const selectedContainer = checkbox.closest('.pet-selected-values')?.querySelector('.selected-conditions');
      if (selectedContainer) renderSelectedConditions(selectedContainer, 'medical', 0);
    });

    pTag.addEventListener('click', () => {
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change'));
    });
  });
});


const prefix = "Dr. ";

document.addEventListener("DOMContentLoaded", function () {
  const input = document.querySelector(".create-new-pet #veterinarian_name");
  if(input){
    input.addEventListener("input", function () {
      // Add "Dr. " only when typing starts
      if (input.value.length > 0 && !input.value.startsWith(prefix)) {
        input.value = prefix + input.value.replace(/^Dr\.\s*/, "");
      }
  
      // Lock the cursor after the prefix
      if (input.selectionStart < prefix.length) {
        input.setSelectionRange(prefix.length, input.value.length);
      }
    });
  }
});











// let presenPetIndex = 1;

// const petBackBtn = document.querySelector('.pet-btn-container .pet-back-btn');
// const petNextBtn = document.querySelector('.pet-btn-container .pet-next-btn');
// const petSubmitBtn = document.querySelector('.pet-btn-container .pet-submit-btn');
// const petDetailscontainer = document.querySelectorAll('.pet-details-container');
// const petbannerImageContainer = document.querySelectorAll('.pet-banner-img');
// const petbannerMsg = document.querySelectorAll('.pet-msg-banner');
// const petSelectorContainer = document.querySelector('.pet-selector');
// const petPopupOverlay = document.querySelector('.pet-popup-msg-overlay');
// const petPopupMsg = document.querySelector('.pet-popup-msg-container');

// const checkRequiredFields = (step) => {
//   // return true;
//   const requiredFields = petDetailscontainer[step - 1]?.querySelectorAll('[required]');
//   const emptyFields = [];

//   for (const field of requiredFields) {
//     if (field.type === 'radio' && !document.querySelector(`input[name="${field.name}"]:checked`)) {
//       emptyFields.push(`Radio button group for ${field.name}`);
//     }
//     if (field.type !== 'radio' && !field.value.trim()) {
//       emptyFields.push(`Field ${field.name}`);
//     }
//   }

//   if (presenPetIndex === 3) {
//     const petData = presentPetData.petexist0;
//     if (
//       petData.selectedMedicalConditions.length === 0
//       // || petData.selectedFlavours.length === 0 ||
//       // petData.selectedToys.length === 0
//     ) {
//       emptyFields.push("Medical conditions, flavours, or toys selection");
//     }
//   }

//   if (emptyFields.length > 0) {
//     showErrorMessage();
//     return false;
//   } else {
//     hideErrorMessage();
//     return true;
//   }
// };

// const showErrorMessage = () => {
//   const msgContainer = document.querySelector('.pet-msg-container');
//   const msgText = document.querySelector('.pet-msg');
//   msgText.innerHTML = "Please fill all required fields to move further.";
//   msgContainer.style.display = 'block';
// };

// const hideErrorMessage = () => {
//   const msgContainer = document.querySelector('.pet-msg-container');
//   msgContainer.style.display = 'none';
// };

// const managePetBtn = () => {
//   if (presenPetIndex === 1) {
//     petBackBtn.style.display = 'none';
//     petNextBtn.style.display = 'block';
//     petSubmitBtn.style.display = 'none';
//     petSelectorContainer.style.opacity = 1;
//   } else if (presenPetIndex === 4) {
//     petBackBtn.style.display = 'block';
//     petNextBtn.style.display = 'none';
//     petSubmitBtn.style.display = 'block';
//     petSelectorContainer.style.opacity = 0;
//   } else {
//     petBackBtn.style.display = 'block';
//     petNextBtn.style.display = 'block';
//     petSubmitBtn.style.display = 'none';
//     petSelectorContainer.style.opacity = 0;
//   }
// };

// const showHidePetContainers = () => {
//   petDetailscontainer.forEach((petDetails, index) => {
//     const isActive = petDetails.classList.contains(`pet-details-${presenPetIndex}`);
//     petDetails.style.display = isActive ? 'block' : 'none';
//     petbannerImageContainer[index].style.display = isActive ? 'block' : 'none';
//     petbannerMsg[index].style.display = isActive ? 'block' : 'none';
//   });
// };

// const updateNextButtonStatus = () => {
//   petNextBtn.disabled = !checkRequiredFields(presenPetIndex);
//   petNextBtn.disabled = false;
// };

// petBackBtn?.addEventListener('click', () => {
//   if (presenPetIndex > 1) {
//     presenPetIndex--;
//     managePetBtn();
//     showHidePetContainers();
//     updateNextButtonStatus();
//   }
// });

// petNextBtn?.addEventListener('click', () => {
//   if (checkRequiredFields(presenPetIndex)) {
//     presenPetIndex++;
//     managePetBtn();
//     showHidePetContainers();
//     updateNextButtonStatus();
//   }
// });

// petDetailscontainer?.forEach(step => {
//   step.addEventListener('input', updateNextButtonStatus);
// });

// updateNextButtonStatus();

function petCreatedPopupMsg(isCreated = false) {
  if (isCreated) {
    petPopupMsg.style.display = 'flex';
    petPopupOverlay.style.display = 'block';
  }
  else {
    petPopupMsg.style.display = 'none';
    petPopupOverlay.style.display = 'none';
  }
}







// ----------------------------------------------------------------------------------------------------------------------------------------------------------------





































document.addEventListener('DOMContentLoaded', async () => {

  if (window.location.href.includes('pet-information')) {

    const blank_profile = getPetIconSvg();

    const customerData = document.getElementById('customer-info-data-pet');
    customerId = customerData?.value;

    let data = [];
    if (customerId) {
      try {
        const response = await fetch(`https://nodejs.animeal.in/api/get-pet?customer_id=${customerId}`);
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        const result = await response.json();

        data = result.data

        // Generate tabs and content dynamically
        if (data?.length > 0) {
          allFormsQty = data.length;
          generateTabsAndContent(data);
        }

      } catch (error) {
        console.error('Error fetching pet data:', error);
      }
    }


    function generateTabsAndContent(petData) {
      // const tabsContainer = document.getElementById('pet-tabs-container');
      const tabsContainer = document.getElementById('added-pets-images-container');
      const tabContentContainer = document.getElementById('pet-tab-content-container');
      console.log('petData: ', petData);
      petData.forEach((pet) => {
        presentPetData[`petexist${pet.id}`] = {
          selectedMedicalConditions: pet.medical_condition && pet.medical_condition !== '[]' ? JSON.parse(pet.medical_condition) : [],
          selectedAllergies: pet.allergies && pet.allergies !== '[]' ? JSON.parse(pet.allergies) : [],
          selectedFlavours: pet.favorite_flavor_preference && pet.favorite_flavor_preference !== '[]' ? JSON.parse(pet.favorite_flavor_preference) : [],
          selectedToys: pet.toy_preferende && pet.toy_preferende !== '[]' ? JSON.parse(pet.toy_preferende) : []
        };

        console.log("presentPetData: ", presentPetData);

        const tabFormData = appendFormsHandler(pet, tabsContainer);
        tabContentContainer.appendChild(tabFormData);
      });
      fillDataInPetFields()

    }

    window.appendEventListnerToFormElms = function appendEventListnerToFormElms() {
      // Debounce the updatePetProfile function
      const debouncedUpdatePetProfile = debounce(updatePetProfile, 1000);

      const petInfoContainers = document.querySelectorAll('.filled-pet-info-container');
      petInfoContainers.forEach((container) => {
        // Get the pet id from the pet image's 'petId' attribute
        const petId = container.querySelector('img').getAttribute('petId');
        const petNumb = container.querySelector('img').getAttribute('petNumb');

        // Select all input fields (text inputs, select elements, textareas) inside the form
        const formFields = container.querySelectorAll('input, select, textarea');


        // Initialize an object to store initial values of the fields
        const initialValues = {};

        formFields.forEach(field => {
          const fieldId = field.id || field.name;

          if (field.type === "radio") {
            // Get the value of the currently selected radio button in the group
            const selectedRadio = container.querySelector(`input[name="${field.name}"]:checked`);
            initialValues[fieldId] = selectedRadio ? selectedRadio.value : null;
          } else {
            initialValues[fieldId] = field.value;
          }
        });

        formFields.forEach(field => {
          field.addEventListener('input', () => {
            debouncedUpdatePetProfile(container, petId, customerId, initialValues, petNumb);
          });
        });

      });
    }

    function debounce(func, delay) {
      let timeout;
      return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => {
          func.apply(this, args);
        }, delay);
      };
    }

    appendEventListnerToFormElms();

  }
});

const editPhotoButton = document.getElementById('edit-pet-profile-photo-empty');
const petProfileInput = document.getElementById('pet-profile-input-empty');
const petProfileImg = document.getElementById('pet-profile-img-empty');
const blankProfile = document.getElementById('blank-profile-empty');

if (window.location.href.includes('pet-information')) {
  // function handlePetApi(){

  blankProfile.addEventListener('click', function () {
    petProfileInput.click(); // This simulates the click on the hidden file input
  });

  // When the "Add/ Edit Pet's Profile Photo" text is clicked, trigger the file input click
  editPhotoButton.addEventListener('click', function () {
    petProfileInput.click(); // This simulates the click on the hidden file input
  });

  // When a file is selected, update the image and hide the blank profile SVG
  petProfileInput.addEventListener('change', function () {
    const file = petProfileInput.files[0];
    const errorMessage = document.getElementById('file-size-error');
    if (errorMessage) {
      errorMessage.remove();
    }

    if (file) {
      if (file.size > 10 * 1024 * 1024) {
        const errorMessage = document.createElement('p');
        errorMessage.id = 'file-size-error';
        errorMessage.textContent = 'The file size exceeds 10MB!';
        errorMessage.style.color = 'red';
        errorMessage.style.fontSize = '10px';
        errorMessage.style.textAlign = 'center';
        errorMessage.style.margin = " 0px ";
        editPhotoButton.closest('.pet-info_add_img').appendChild(errorMessage);
        return;
      }
      const reader = new FileReader();

      // When the file is loaded (i.e., the image is read), update the image
      reader.onload = function (e) {
        const imageUrl = e.target.result;

        // Set the image source to the selected file
        petProfileImg.src = imageUrl;

        // Make the image visible and hide the blank profile SVG
        petProfileImg.style.display = 'block';
        blankProfile.style.display = 'none';
      };

      // Read the file as a data URL
      reader.readAsDataURL(file);
    }
  });

}


// Function to collect only the changed data and send to the API
function updatePetProfile(container, petId, customerId, initialValues, petNumb) {
  const formData = new FormData();
  const formFields = container.querySelectorAll('input, select, textarea');
  let hasChanges = false;

  formFields.forEach(field => {
    const fieldId = field.id || field.name;
    let currentValue = field.type === "radio" ?
      (container.querySelector(`input[name="${field.name}"]:checked`)?.value || null) : field.value.trim();

    if (currentValue !== initialValues[fieldId]) {
      initialValues[fieldId] = currentValue;

      if (field.type === "file" && field.files[0]) {
        hasChanges = true;
        formData.append('pet_image', field.files[0]);
      } else if (field.type === "radio" && field.checked && !['allergies', 'medical', 'flavours', 'toy'].includes(fieldId)) {
        console.log('entered in radio:', 'field.type', field.type, 'field.checkbox', field.checkbox, 'field.value:', field.value)
        hasChanges = true;
        formData.append(fieldId.includes('gender') ? 'gender' : 'species', field.value.trim());
      } else if (field.type !== "file" && !['breed','allergies', 'medical', 'flavours', 'toy'].includes(fieldId)) {
        hasChanges = true;
        formData.append(fieldId, currentValue);
      }
    }
  });

  if (!hasChanges) return;

  formData.append('customer_id', customerId);
  formData.append('pet_id', petId);
  formData.append('petNumbEmpty', petNumb);

  fetch(`https://nodejs.animeal.in/api/update-pet-profile?customer_id=${customerId}&pet_numb=${petId}`, {
    method: 'PATCH',
    body: formData
  })
    .then(response => response.ok ? response.json() : Promise.reject('API Error'))
    .then(data => { })
    .catch(error => {
      console.error('Error updating pet profile:', error);
      // alert('An error occurred while updating the pet profile.');
    });
}




function getPetIconSvg() {
  return (`<svg viewBox="0 0 489.108 489.108" xml:space="preserve"><path d="m488.895 349.458-35.6-155.711a9 9 0 0 0-.276-.938c-2.71-9.849-15.761-17.291-41.196-23.553-4.838-25.417-27.213-44.697-54.018-44.697q-2.566 0-5.136.243c-9.346-18.041-28.186-29.743-48.864-29.743a55.2 55.2 0 0 0-18.488 3.197c-8.821-13.709-24.037-22.197-40.762-22.197s-31.94 8.487-40.762 22.197a55.2 55.2 0 0 0-18.488-3.197c-20.678 0-39.518 11.703-48.864 29.743a55 55 0 0 0-5.136-.243c-26.805 0-49.18 19.28-54.018 44.697-26.029 6.409-39.096 14.05-41.376 24.245-.034.124-.076.244-.104.371L.214 349.457A8.5 8.5 0 0 0 0 351.352c0 16.291 25.438 30.818 75.605 43.178 48.476 11.943 108.477 18.52 168.949 18.52s120.473-6.577 168.949-18.52c50.168-12.36 75.605-26.887 75.605-43.177a8.5 8.5 0 0 0-.213-1.895m-76.601-162.519c16.179 4.391 21.832 8.251 23.652 9.917-2.092 1.92-9.26 6.749-31.548 11.909a54.9 54.9 0 0 0 7.896-21.826m-280.99-45.381c2.799 0 5.626.318 8.403.944a8.5 8.5 0 0 0 9.862-5.395c5.432-14.983 19.792-25.05 35.735-25.05a38 38 0 0 1 18.211 4.642 8.503 8.503 0 0 0 11.933-4.199c4.9-11.812 16.325-19.443 29.107-19.443s24.206 7.632 29.106 19.443a8.5 8.5 0 0 0 11.933 4.199 38 38 0 0 1 18.211-4.642c15.943 0 30.303 10.067 35.735 25.05a8.5 8.5 0 0 0 9.862 5.395 38.3 38.3 0 0 1 8.403-.944c20.953 0 37.431 17.055 38 38 .394 14.497-9.948 27.233-20.027 34.521-36.225 5.436-82.663 8.422-131.223 8.422-47.355 0-92.688-2.841-128.503-8.023-13.38-6.24-22.747-20.152-22.747-34.92-.001-20.953 17.046-38 37.999-38M76.811 186.94a55 55 0 0 0 7.916 21.829c-22.3-5.161-29.472-9.992-31.564-11.913 1.819-1.666 7.471-5.525 23.648-9.916m328.853 191.996c-46.549 11.037-103.766 17.115-161.109 17.115s-114.56-6.078-161.11-17.115c-45.854-10.872-64.007-22.733-66.28-27.342L48.577 214.28c3.222 1.808 6.261 3.032 8.048 3.751 10.661 4.292 25.707 8.11 44.719 11.348 38.329 6.527 89.188 10.122 143.211 10.122s104.882-3.595 143.21-10.122c19.012-3.238 34.058-7.056 44.719-11.348 1.79-.721 4.836-1.947 8.065-3.76l31.396 137.322c-2.272 4.608-20.425 16.47-66.281 27.343"/><path d="M347.956 246.28c-19.751 0-36.191 14.451-39.304 33.333H180.456c-3.112-18.883-19.553-33.333-39.304-33.333-21.964 0-39.833 17.869-39.833 39.833a39.74 39.74 0 0 0 8.042 24 39.74 39.74 0 0 0-8.042 24c0 21.964 17.869 39.833 39.833 39.833 19.751 0 36.191-14.451 39.304-33.333h128.196c3.112 18.883 19.553 33.333 39.304 33.333 21.964 0 39.833-17.869 39.833-39.833a39.74 39.74 0 0 0-8.042-24 39.74 39.74 0 0 0 8.042-24c0-21.964-17.869-39.833-39.833-39.833m14.67 70.343a22.8 22.8 0 0 1 8.163 17.491c0 12.59-10.243 22.833-22.833 22.833-12.591 0-22.834-10.243-22.834-22.833 0-.491.02-.978.051-1.461a8.496 8.496 0 0 0-8.483-9.038H172.418a8.5 8.5 0 0 0-8.483 9.038c.031.483.051.97.051 1.461 0 12.59-10.243 22.833-22.834 22.833s-22.833-10.243-22.833-22.833a22.8 22.8 0 0 1 8.163-17.491 8.5 8.5 0 0 0 0-13.018 22.8 22.8 0 0 1-8.163-17.491c0-12.59 10.243-22.833 22.833-22.833 12.591 0 22.834 10.243 22.834 22.833 0 .491-.02.978-.051 1.461a8.496 8.496 0 0 0 8.483 9.038H316.69a8.5 8.5 0 0 0 8.483-9.038c-.031-.483-.051-.97-.051-1.461 0-12.59 10.243-22.833 22.834-22.833s22.833 10.243 22.833 22.833a22.8 22.8 0 0 1-8.163 17.491 8.5 8.5 0 0 0 0 13.018"/></svg>`)
}

// Function to handle tab switching
function openTab(index) {
  const tabContent = document.getElementsByClassName('tab-content');
  Array.from(tabContent).forEach((content, i) => {
    const petFormId = content?.id;

    if (petFormId) {
      // const petFormIdNum = petFormId.split("").pop();
      const petFormIdNum = petFormId.replace(/\D/g, '');
      content.style.display = (petFormIdNum == index) ? 'block' : 'none';
    }
  });

  const tabButtons = document.getElementsByClassName('tab-button');
  Array.from(tabButtons).forEach((btn, i) => {
    const tabBtnId = btn?.id;
    if (tabBtnId) {
      const tabBtnIdNum = tabBtnId?.replace(/\D/g, '');
      btn.classList.remove('active');
      if (tabBtnIdNum == index) btn.classList.add('active');
    }
  });
}

function addNewPetHandler(e) {
  e.preventDefault();
  const form = e.target;
  const formData = new FormData();
  const submitButton = form.querySelector('#submit-pet-info');
  submitButton.setAttribute('disabled', true);
  submitButton.querySelector('.submit-txt').style.display = 'none';
  submitButton.querySelector('.customer-info-loader').style.display = 'block';

  const petData = {
    veterinarian_name: form.querySelector('#veterinarian_name').value,
    pet_name: form.querySelector('#pet_name').value,
    species: form.querySelector('input[name="specie"]:checked')?.value,
    breed: form.querySelector('#breed').value,
    gender: form.querySelector('input[name="gender"]:checked')?.value,
    birthdate: form.querySelector('#birthdate').value,
    weight: form.querySelector('input[name="weight"]:checked')?.value,
    allergies: JSON.stringify(presentPetData[`petexist0`].selectedAllergies),
    medical_condition: JSON.stringify(presentPetData[`petexist0`].selectedMedicalConditions),
    favorite_flavor_preference: JSON.stringify(presentPetData[`petexist0`].selectedFlavours),
    toy_preferende: JSON.stringify(presentPetData[`petexist0`].selectedToys),
    customer_id: document.getElementById('customer-info-data-pet')?.value,
    pet_image: document.getElementById('pet-profile-input-empty').files[0] || null,
    set_refill_reminder: form.querySelector('#refill-reminder')?.value || null,
    birthday_reminder: form.querySelector('.pet-reminders_changed .pet-switch input').checked ? 1 : 0
  };

  Object.entries(petData).forEach(([key, value]) => value && formData.append(key, value));

  // const petNumb = document.querySelector('.pet_numb_empty').textContent.trim();
  // const petNumb = document.querySelectorAll('.pet-info-container.filled-pet-info-container')?.length || 0;
  const currentDate = new Date();
  const petNumb = `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}_${String(currentDate.getHours()).padStart(2, '0')}-${String(currentDate.getMinutes()).padStart(2, '0')}-${String(currentDate.getSeconds()).padStart(2, '0')}`;

  console.log('petNumb: ', petNumb)


  const apiUrl = `https://nodejs.animeal.in/api/create-pet-info?customer_id=${customerId}&pet_numb=${petNumb}`;

  fetch(apiUrl, { method: 'POST', body: formData })
    .then(response => response.json())
    .then(data => {
      if (data.message === 'Pet created successfully') {
        const tabsContainer = document.getElementById('added-pets-images-container');
        const tabContentContainer = document.getElementById('pet-tab-content-container');
        const tabFormData = appendFormsHandler(data.response, tabsContainer);
        presentPetData[`petexist${data.response.id}`] = {
          selectedMedicalConditions: data.response.medical_condition && data.response.medical_condition !== '[]' ? JSON.parse(data.response.medical_condition) : [],
          selectedAllergies: data.response.allergies && data.response.allergies !== '[]' ? JSON.parse(data.response.allergies) : [],
          selectedFlavours: data.response.favorite_flavor_preference && data.response.favorite_flavor_preference !== '[]' ? JSON.parse(data.response.favorite_flavor_preference) : [],
          selectedToys: data.response.toy_preferende && data.response.toy_preferende !== '[]' ? JSON.parse(data.response.toy_preferende) : []
        };
        document.querySelectorAll('.pet-info-container.create-new-pet .pet-medical-condition .selected-conditions').forEach((selectedCondition) => selectedCondition.innerHTML = '');

        tabContentContainer.appendChild(tabFormData);

        form.reset();
        document.getElementById('blank-profile-empty').style.display = 'block';
        document.getElementById('pet-profile-img-empty').style.display = 'none';
        appendEventListnerToFormElms();
        fillDataInPetFields();
        petCreatedPopupMsg(true);
        presenPetIndex = 1;
        managePetBtn();
        showHidePetContainers();
        // updateNextButtonStatus();
        presentPetData.petexist0 = {
          selectedMedicalConditions: [],
          selectedAllergies: [],
          selectedFlavours: [],
          selectedToys: []
        };
        document.querySelectorAll('.pet-into-upper-container .tab-content').forEach(tabContent => {
          tabContent.style.display = 'none'
        });
        console.log('`pet${data.response.id}` ', `pet${data.response.id}`)
        document.getElementById(`pet${data.response.id}`).style.display = 'block';

      }
      // petFormNotification.querySelector('span').innerText = data.message;
      // petFormNotification.style.display = 'block';
      // setTimeout(() => petFormNotification.style.display = 'none', 3000);
    })
    .catch(() => {
      // petFormNotification.querySelector('span').innerText = "Something went wrong, please try again.";
      // petFormNotification.style.display = 'block';
      // setTimeout(() => petFormNotification.style.display = 'none', 3000);
    })
    .finally(() => {
      submitButton.querySelector('.submit-txt').style.display = 'block';
      submitButton.querySelector('.customer-info-loader').style.display = 'none';
      submitButton.removeAttribute('disabled');
    });
}


function appendFormsHandler(pet, tabsContainer) {
  // Create tab button
  const tabButton = document.createElement('div');
  tabButton.classList.add('tab-button');
  tabButton.id = `tab-btn-${pet.id}`;
  
  const petImage = document.createElement('img');
  petImage.src = pet.pet_image ? `https://nodejs.animeal.in/uploads/${pet.pet_image}` : 'https://t4.ftcdn.net/jpg/09/73/00/49/360_F_973004905_S7DgbsFQuKzHx8USHBj9cgfR6f9EztKp.jpg';
  petImage.alt = `Pet ${pet.id}`;
  petImage.classList.add('menu-pet-photo');
  tabButton.appendChild(petImage);
  tabButton.onclick = () => openTab(pet.id);
  tabsContainer.appendChild(tabButton);

  // Create tab content
  const tabContent = document.createElement('div');
  tabContent.classList.add('tab-content');
  tabContent.id = `pet${pet.id}`;
  tabContent.style.display = 'none';

  // Species options
  const speciesOptions = [
    { value: 'Dog', label: 'Dog' },
    { value: 'Cat', label: 'Cat' },
    { value: 'Farm Animals', label: 'Farm Animals' },
    { value: 'Fish/Reptile', label: 'Fish/Reptile' },
    { value: 'Birds', label: 'Birds' }
  ];

  // Generate species radio buttons dynamically
  const speciesRadios = speciesOptions.map(option => `
    <input type="radio" id="specie-${pet.id}-${option.value.replace(/\s+/g, '-')}" 
           name="specie-${pet.id}" value="${option.value}" 
           ${pet.species === option.value ? 'checked' : ''}>
    <label for="specie-${pet.id}-${option.value.replace(/\s+/g, '-')}">${option.label}</label>
  `).join('');

  // Allergies options
  const allergiesOptions = [
    'Beef', 'Chicken', 'Dairy products', 'Eggs', 'Fish', 'Lamb', 'Soy',
    'Wheat and gluten', 'Pollen', 'Dust mites', 'Mold spores',
    'Household cleaners and chemicals', 'Cigarette smoke',
    'Perfumes and air fresheners', 'Flea saliva', 'Fabrics', 'Plastic'
  ];

  // Generate allergies checkboxes dynamically
  const allergiesCheckboxes = allergiesOptions.map(allergy => `
    <label>
      <input type="checkbox" name="allergies" value="${allergy}" 
             onchange="changeInMultiselectCheckbox(this)" 
             ${JSON.parse(pet.allergies || '[]').includes(allergy) ? 'checked' : ''}>
      <p>${allergy}</p>
    </label><br>
  `).join('');

  // Favorite flavors options
  const flavorOptions = [
    'Chicken', 'Lamb', 'Fish (any Fish Flavour)', 'Meat', 'Turkey', 'Duck',
    'Salmon', 'Sardine', 'Egg', 'Quail', 'Tuna', 'Milk', 'Cheese',
    'Whitefish', 'Mackerel', 'Ocean Fish', 'Prawn/Shrimp', 'Crab', 'Herring'
  ];

  // Generate flavor checkboxes dynamically
  const flavorCheckboxes = flavorOptions.map(flavor => `
    <label>
      <input type="checkbox" name="flavours" value="${flavor}" 
             onchange="changeInMultiselectCheckbox(this)" 
             ${JSON.parse(pet.favorite_flavor_preference || '[]').includes(flavor) ? 'checked' : ''}>
      <p>${flavor}</p>
    </label><br>
  `).join('');

  // Toy preferences options
  const toyOptions = pet.species == 'Dog' ? [
    'Chew Toys', 
    'Interactive & Puzzle Toys', 
    'Fetch & Retrieval Toys',
    'Tug Toys', 
    'Squeaky & Sound Toys', 
    'Balls & Rolling Toys',   
    'Training & Behavioral Toys', 
    'Soft Toys'
  ] : pet.species == 'Cat' ? [
    'Interactive Toys',
    'Feather & Wand Toys',
    'Catnip & Herbal Toys',
    'Ball & Rolling Toys',
    'Climbing & Scratching Toys',
    'Teething & Chew Toys',
    'Sound & Motion Toys',
    'Soft Toys',
    'Tunnels & Hideaways'
  ] : pet.species == 'Farm Animals' ? [
    'Rubber Chew Toys',
    'Treat Balls',
    'Tug Toys',
    'Scratchers',
    'Hanging Hay Nets',
    'Foam Balls',
    'Horse Balls',
    'Jolly Balls'
  ] : pet.species == 'Fish/Reptile' ? [
    'Aquarium Decorations',
    'Floating Logs',
    'Climbing Rocks',
    'Suction Cup Toys',
    'Basking Platforms',
    'Tunnels & Hides',
    'Foraging Mats',
    'Reptile Climbing Branches'
  ] : pet.species == 'Birds' ? [
    'Chew Toys',
    'Foraging Toys',
    'Swing Toys',
    'Bell Toys',
    'Foot Toys',
    'Shredding Toys',
    'Mirror Toys',
    'Climbing Ladders',
    'Wobble Toys'
  ] : [];
  
  // Generate toy checkboxes dynamically
  const toyCheckboxes = toyOptions.map(toy => `
    <label>
      <input type="checkbox" name="toy" value="${toy}" 
             onchange="changeInMultiselectCheckbox(this)" 
             ${JSON.parse(pet.toy_preferende || '[]').includes(toy) ? 'checked' : ''}>
      <p>${toy}</p>
    </label><br>
  `).join('');

  // Set the HTML content
  tabContent.innerHTML = `
    <form class="pet-info-container filled-pet-info-container petInflo_edits_wrapper">

      <div class="pet-info-heading-container">
        <h2 class='cus_pet_info_heading'>Pet Information Form</h2>
        <div class="pet-edit-enable-btn"><span>Edit</span></div>
        <div class="delete-pet-btn" petId="${pet.id}" onclick="deletePetHandler(${pet.id}, ${pet.id})">
          <svg fill="#c32727" xmlns="http://www.w3.org/2000/svg" width="25px" height="25px" viewBox="0 0 52 52" enable-background="new 0 0 52 52" xml:space="preserve">
            <g>
              <path d="M45.5,10H33V6c0-2.2-1.8-4-4-4h-6c-2.2,0-4,1.8-4,4v4H6.5C5.7,10,5,10.7,5,11.5v3C5,15.3,5.7,16,6.5,16h39c0.8,0,1.5-0.7,1.5-1.5v-3C47,10.7,46.3,10,45.5,10z M23,7c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1v3h-6V7z"/>
              <path d="M41.5,20h-31C9.7,20,9,20.7,9,21.5V45c0,2.8,2.2,5,5,5h24c2.8,0,5-2.2,5-5V21.5C43,20.7,42.3,20,41.5,20z M23,42c0,0.6-0.4,1-1,1h-2c-0.6,0-1-0.4-1-1V28c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1V42z M33,42c0,0.6-0.4,1-1,1h-2c-0.6,0-1-0.4-1-1V28c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1V42z"/>
            </g>
          </svg>
        </div>
      </div>

      <div class="pet-details-1st pet_info_profile_edits pointer_none">

        <div class="pet_numb" style="display:none;">${pet.id}</div>  

        <div class="pet-info_container_profile">
          <div class="pet-info_container_img">
            <img src="${pet.pet_image ? `https://nodejs.animeal.in/uploads/${pet.pet_image}` : 'https://t4.ftcdn.net/jpg/09/73/00/49/360_F_973004905_S7DgbsFQuKzHx8USHBj9cgfR6f9EztKp.jpg'}" 
                alt="Pet Profile" 
                id="pet${pet.id}-image" 
                class="pet-profile-img" 
                petId="${pet.id}" 
                petNumb="${pet.id}" />
          </div>
          <div class="pet-info_add_img petInflo_edit_items d_none">
            <span id="edit-pet-profile-photo" class="edit-pet-profile-photo" onclick="selectFileHandler(this)">Add/ Edit Pet's Profile Photo</span>
            <input class="pet-profile-input" type="file" onchange="updatePetProfileInpHandler(this, ${pet.id})" style="display: none;" accept="image/*"/>
          </div>
          
          <div class="veterinarian-name">
            <input type="text" id="pet_name" placeholder="Enter Your Pet's Name" value="${pet.pet_name || ''}" petId="${pet.id}" required>
          </div>
        </div>

        <div class="pet-breed" petId="${pet.id}">
          <div class="pet_edits__container">
            <label for="breed" class="ptinfo_edit_label">Vet Name</label> <div class="ptinfo_edit_label_value pet_edits_breed_val petInflo_edit_items breed_update_${pet.id}">${pet.veterinarian_name || ''}</div>
          </div>
          <div class="petInflo_edit_items d_none">
            <input type="text" class="ptinfo_edit_label_value" id="veterinarian_name" placeholder="Enter Your veterinarian Name" value="${pet.veterinarian_name || ''}" onkeyup="vetSearchHelp(this)" required>
            <div id="vet-suggestions" class="vet-suggestions-box"></div>
          </div>
        </div>

        
        
        <div class="pet-species" petId="${pet.id}">
          <div class="pet_edits__container">
            <h3 class="ptinfo_edit_label">Species</h3> <div class="ptinfo_edit_label_value pet_edits_species_val petInflo_edit_items species_update_${pet.id}" >${pet.species}</div>
          </div>
          <div class="species-container species-container-dynamic ptinfo_edit_label_value petInflo_edit_items d_none">
            ${speciesRadios}
          </div>
        </div>
        
        <div class="pet-breed" petId="${pet.id}">
          <div class="pet_edits__container">
            <label for="breed" class="ptinfo_edit_label">Breed</label> <div class="ptinfo_edit_label_value pet_edits_breed_val petInflo_edit_items breed_update_${pet.id}">${pet.breed}</div>
          </div>
          <div class="petInflo_edit_items d_none">
            <input type="text" id="breed" name="breed" class="ptinfo_edit_label_value" placeholder="Enter breed" oninput="changeInBreed(this, ${pet.id})" value="${pet.breed || ''}">
          </div>
        </div>
        
        <div class="gender" petId="${pet.id}">
          <div class="pet_edits__container">
            <h3 class="ptinfo_edit_label">Gender</h3> <div class="ptinfo_edit_label_value pet_edits_gender_val petInflo_edit_items gender_update_${pet.id}">${pet.gender}</div>
          </div>
          <div class="gender-container ptinfo_edit_label_value petInflo_edit_items d_none">
            <input type="radio" id="gender-${pet.id}-male" name="gender-${pet.id}" value="Male" ${pet.gender === 'Male' ? 'checked' : ''}>
            <label for="gender-${pet.id}-male">Male</label>
            <input type="radio" id="gender-${pet.id}-female" name="gender-${pet.id}" value="Female" ${pet.gender === 'Female' ? 'checked' : ''}>
            <label for="gender-${pet.id}-female">Female</label>
          </div>
        </div>
        
        <div class="birthdate" petId="${pet.id}">
          <div class="pet_edits__container">
            <h3 class="ptinfo_edit_label">Birth Date</h3> <div class="ptinfo_edit_label_value pet_edits_birthDate_val petInflo_edit_items birthdate_update_${pet.id}">${pet.birthdate}</div>
          </div>
           <div class="petInflo_edit_items d_none">
            <input type="date" class="ptinfo_edit_label_value" id="birthdate" onclick="openCalendar(this)" value="${pet.birthdate || ''}" required>
          </div>
        </div>

        ${['Dog', 'Cat'].includes(pet.species) ? `
        <div class="pet-health-info" petId="${pet.id}">
          <div class="pet_edits__container">
            <h3 class="ptinfo_edit_label">Pet Weight</h3> <div class="ptinfo_edit_label_value pet_edits_weight_val petInflo_edit_items weight_update_${pet.id}">${pet.weight}</div>
          </div>
          <div class="petInflo_edit_items d_none">
            <input type="text" id="weight" class="ptinfo_edit_label_value" value="${pet.weight || ''}" maxlength="10" placeholder="Weight" required>   
          </div>
        </div>
      </div>
      
      <div class="pet-details-2nd pet_info_profile_edits pointer_none">
        <div class="pet_edits__container">
          <h3 class="ptinfo_edit_label">Allergies</h3> <div class="ptinfo_edit_label_value pet_edits_allergies_val petInflo_edit_items allergies_update_${pet.id}">${JSON.parse(pet.allergies || '[]')}</div>
        </div>
        <div class="pet-allergies pet-selected-values petInflo_edit_items d_none">
          <div class="selected-conditions ptinfo_edit_label_value" data-pet-id="${pet.id}">
            ${allergiesCheckboxes}
          </div>
        </div>
        
        <div class="pet-medical-condition pet-selected-values pet-suggestion-field" petId="${pet.id}" data-id-value="${pet.id}-medical">
          <div class="pet_edits__container">
            <label for="medical" class="ptinfo_edit_label">Medical Condition</label> <div class="ptinfo_edit_label_value pet_edits_medicalCondition_val petInflo_edit_items medical_update_${pet.id}">${JSON.parse(pet.medical_condition || '[]')}</div>
          </div>

          <div class="petInflo_edit_items d_none">
            <div class="selected-conditions"></div>
            <input type="text" id="medical" name="medical" class="ptinfo_edit_label_value" placeholder="Enter medical condition" oninput="changeInMedican(this, ${pet.id})">
          </div>
        </div>
        
        <div class="pet-preferences" petId="${pet.id}">
          <div class="flavors-container pet-selected-values pet-suggestion-field" petId="${pet.id}" data-id-value="${pet.id}-flavours">
            <div class="pet_edits__container">
              <h3 class="ptinfo_edit_label">Favorite Flavors</h3> <div class="ptinfo_edit_label_value pet_edits_flavourChekbox_val petInflo_edit_items flavours_update_${pet.id}">${JSON.parse(pet.favorite_flavor_preference || '[]')}</div>
            </div>
            <div class="petInflo_edit_items d_none">
              <div class="selected-conditions ptinfo_edit_label_value" data-pet-id="${pet.id}">
                ${flavorCheckboxes}
              </div>
            </div>
          </div>
          
          <div class="toys-container pet-selected-values pet-suggestion-field" petId="${pet.id}" data-id-value="${pet.id}-toys">
            <div class="pet_edits__container">
              <h3 class="ptinfo_edit_label">Toy Preferences</h3> <div class="ptinfo_edit_label_value pet_edits_toyCheckboxes_val petInflo_edit_items toys_update_${pet.id}">${JSON.parse(pet.toy_preferende || '[]')}</div>
            </div>
            <div class="petInflo_edit_items d_none">
              <div class="selected-conditions ptinfo_edit_label_value" data-pet-id="${pet.id}">
                ${toyCheckboxes}
              </div>
            </div>
          </div>
        </div>
      </div>
      ` : ''}
      
      <div class="pet-edit-disable-btn"><span>Save</span></div>
    </form>
  `;
  return tabContent;
}


document.addEventListener("click", function (e) {

  const petInfoEditConatiner =  e.target.closest(".pet-info-container");
  if (e.target.closest(".pet-edit-enable-btn")) {
    petInfoEditConatiner.querySelectorAll(".pet_info_profile_edits .petInflo_edit_items")?.forEach((e) => e.classList.toggle("d_none"));
    petInfoEditConatiner.querySelectorAll(".pet_info_profile_edits").forEach(e => e.classList.toggle("pointer_none"));
  }
  const button = e.target.closest(".pet-edit-enable-btn");
  if(button){
    if (button.innerText === "Edit") {
      button.innerText = "Save";
      button.classList.add("save_pet_edit");
      button.classList.remove("edit_pet_info");

    } else {
      button.innerText = "Edit";
      button.classList.add("edit_pet_info");
      button.classList.remove("save_pet_edit");
    }
  }
})

function selectFileHandler(spanElement) {
  let inputElement = spanElement.closest('.pet-info_add_img').querySelector('input[type="file"]');
  if (inputElement) {
    inputElement.click();
  }
}

function updatePetProfileInpHandler(petProfileInput, formIndx) {

  let petProfileImg = petProfileInput.closest('.pet-info_container_profile').querySelector('.pet-profile-img');
  const allMenuPhoto = document.querySelector(`#tab-btn-${formIndx} img`);

  const file = petProfileInput.files[0]; // Get the selected file
  const errorMessage = document.getElementById('file-size-error');
  if (errorMessage) {
    errorMessage.remove();
  }
  if (file) {
    // console.log('file size: ', file.size);
    if (file.size > 10 * 1024 * 1024) {
      const errorMessage = document.createElement('p');
      errorMessage.id = 'file-size-error';
      errorMessage.textContent = 'The file size exceeds 10MB!';
      errorMessage.style.color = 'red';
      errorMessage.style.fontSize = '10px';
      errorMessage.style.textAlign = 'center';
      errorMessage.style.margin = " 0px ";
      petProfileInput.closest('.pet-info_add_img').appendChild(errorMessage);
      return;
    }
    const reader = new FileReader();

    // When the file is loaded (i.e., the image is read), update the image
    reader.onload = function (e) {
      const imageUrl = e.target.result;

      // Set the image source to the selected file
      petProfileImg.src = imageUrl;
      allMenuPhoto.src = imageUrl;

      // Make the image visible and hide the blank profile SVG
      // petProfileImg.style.display = 'block';
    };

    // Read the file as a data URL
    reader.readAsDataURL(file);
  }
}

async function deletePetHandler(petId, indx) {
  const petFormNotification = document.querySelector('.pet-form-notification-wrapper');

  if (confirm("Are you sure you want to delete the pet?")) {
    try {

      const apiUrl = `https://nodejs.animeal.in/api/delete-pet`; // Replace with your actual API URL

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ pet_id: petId })
      })
      const result = await response.json();
      if (result.response) {
        document.querySelector(`#tab-btn-${indx}`)?.remove();
        document.querySelector(`#pet${indx}`)?.remove();
        openTab(0);

      }
      petFormNotification.querySelector('span').innerText = result.message;
      petFormNotification.style.display = 'block';
      setTimeout(() => {
        petFormNotification.style.display = 'none';
      }, 2500)

    } catch (error) {
      //   console.log(error,'something went wrong');
      petFormNotification.querySelector('span').innerText = "Something went wrong, please try again.";
      petFormNotification.style.display = 'block';
      setTimeout(() => {
        petFormNotification.style.display = 'none';
      }, 2500)
    }
  }
}

function openCalendar(elm) {
  // console.log('pet birthdate')
  elm.showPicker()
}


// appending data regarding the selection of radio button

// function showSuggestions(input, suggestions, breedKey, searchTerm, petId) {
//   let suggestionList = input.nextElementSibling;
//   if (suggestionList && suggestionList.classList.contains('suggestions')) suggestionList.remove();

//   suggestionList = document.createElement('ul');
//   suggestionList.classList.add('suggestions');
//   input.parentNode.appendChild(suggestionList);

//   const createSuggestionItem = (text) => {
//     const item = document.createElement('li');
//     item.textContent = text;
//     item.addEventListener('click', () => {
//       input.value = text;
//       console.log('updatePetID: ', petId)
//       if(petId != 0)
//       {
//         updatePetInputFields(petId, 'breed', text);
//         document.querySelector(`.breed_update_${petId}`).innerHTML = text;
//       }
//       suggestionList.remove();
//     });
//     return item;
//   };

//   if (suggestions.length) {
//     suggestions.forEach(suggestion => {
//       suggestionList.appendChild(createSuggestionItem(suggestion[breedKey]));
//     });
//   }
//   else {
//     suggestionList.appendChild(createSuggestionItem(searchTerm));
//   }
// }

function showSuggestions(input, suggestions, breedKey, searchTerm, petId) {
  let suggestionList = input.nextElementSibling;

if (suggestionList?.classList.contains('suggestions')) {
  suggestionList.remove();
} else if (suggestionList?.nextElementSibling?.classList.contains('suggestions')) {
  suggestionList.nextElementSibling.remove();
}

  suggestionList = document.createElement('div');
  suggestionList.classList.add('suggestions');
  input.parentNode.appendChild(suggestionList);

  const createSuggestionItem = (text) => {
    const container = document.createElement('div');
    container.classList.add('suggestion-item');

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.value = text;
    checkbox.name = breedKey;
    checkbox.addEventListener('click', () => {
      input.value = text;
      console.log('updatePetID: ', petId)
      if(petId != 0)
      {
        updatePetInputFields(petId, 'breed', text);
        document.querySelector(`.breed_update_${petId}`).innerHTML = text;
      }
      suggestionList.remove();
    });
    const label = document.createElement('p');
    label.textContent = text;
    label.addEventListener('click', () => {
      input.value = text;
      console.log('updatePetID: ', petId)
      if(petId != 0)
      {
        updatePetInputFields(petId, 'breed', text);
        document.querySelector(`.breed_update_${petId}`).innerHTML = text;
      }
      suggestionList.remove();
    });

    container.appendChild(label);
    container.appendChild(checkbox);

    return container;
  };

  if (suggestions.length) {
    suggestions.forEach(suggestion => {
      suggestionList.appendChild(createSuggestionItem(suggestion[breedKey]));
    });
  }
  else {
    suggestionList.appendChild(createSuggestionItem(searchTerm));
  }
}

function showSuggestionsAndValues(input, suggestions, conditionKey, itsType, searchTerm, petId) {
  let suggestionList = input.nextElementSibling;
  if (suggestionList && suggestionList.classList.contains('suggestions')) suggestionList.remove();

  suggestionList = document.createElement('div');
  suggestionList.classList.add('suggestions');
  input.parentNode.appendChild(suggestionList);

  const createSuggestionItem = (text) => {
    const container = document.createElement('div');
    container.classList.add('suggestion-item');

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.value = text;
    checkbox.name = itsType;
    checkbox.addEventListener('change', () => {
      addsuggestedValues(text, itsType, petId, checkbox.checked);
      const parentContainer = input.closest('.pet-selected-values');
      const selectedConditionsContainer = parentContainer?.querySelector('.selected-conditions');
      if (selectedConditionsContainer) renderSelectedConditions(selectedConditionsContainer, itsType, petId);
      input.value = '';
    });

    const label = document.createElement('p');
    label.textContent = text;

    label.addEventListener('click', () => {
      checkbox.checked = !checkbox.checked;
      checkbox.dispatchEvent(new Event('change'));
    });

    container.appendChild(label);
    container.appendChild(checkbox);

    return container;
  };

  if (suggestions.length) {
    suggestions.forEach(suggestion => {
      suggestionList.appendChild(createSuggestionItem(suggestion[conditionKey]));
    });
  }
  else {
    suggestionList.appendChild(createSuggestionItem(searchTerm));
  }
}


function removeSuggestions(input) {
  let suggestionList = input.nextElementSibling;
  let suggestionList2nd = input.nextElementSibling?.nextElementSibling
  if (input.nextElementSibling && input.nextElementSibling.classList.contains('suggestions')) suggestionList.remove();
  else if (suggestionList2nd && suggestionList2nd.classList.contains('suggestions')) suggestionList2nd.remove();
}

function changeInMultiselectCheckbox(input) {
  const petId = input.closest('.selected-conditions').getAttribute('data-pet-id');
  const inputValue = input.value;
  const itsType = input.name;
  addsuggestedValues(inputValue, itsType, petId, input.checked);
}

function addsuggestedValues(inputValue, itsType, petId, isChecked = false, prntContainer = null) {
  const petData = presentPetData[`petexist${petId}`];
  if (itsType === 'medical') {
    if (isChecked) {
      if (!petData.selectedMedicalConditions.includes(inputValue)) {
        if (inputValue === 'Perfectly Healthy (Touch Wood)') {
          petData.selectedMedicalConditions = [];
  
          const allInputs = prntContainer?.querySelectorAll('input[name="medical"]');
          allInputs?.forEach(singleInput => {
            if (singleInput.value !== 'Perfectly Healthy (Touch Wood)') {
              singleInput.checked = false;
            }
          });
        } else {
          const index = petData.selectedMedicalConditions.indexOf('Perfectly Healthy (Touch Wood)');
          if (index !== -1) {
            petData.selectedMedicalConditions.splice(index, 1);
            const healthyInput = prntContainer?.querySelector('input[value="Perfectly Healthy (Touch Wood)"]');
            if (healthyInput) healthyInput.checked = false;
          }
        }
        petData.selectedMedicalConditions.push(inputValue);
      }
    } else {
      const index = petData.selectedMedicalConditions.indexOf(inputValue);
      if (index !== -1) {
        petData.selectedMedicalConditions.splice(index, 1);
      }
    }
    if (petId !== 0) {
      document.querySelector(`.medical_update_${petId}`).innerHTML = petData.selectedMedicalConditions;
    }
  }
  else if (itsType === 'allergies') {
    if (isChecked) {
      if (!petData.selectedAllergies.includes(inputValue)) petData.selectedAllergies.push(inputValue);
    } else {
      const index = petData.selectedAllergies.indexOf(inputValue);
      if (index !== -1) petData.selectedAllergies.splice(index, 1);
    }
    console.log('selectedAllergies: ', petData.selectedAllergies);
    if(petId != 0){
      document.querySelector(`.allergies_update_${petId}`).innerHTML = petData.selectedAllergies;
      updatePetInputFields(petId, 'allergies', JSON.stringify(petData.selectedAllergies))
    }
  } 
  else if (itsType === 'flavours') {
    if (isChecked) {
      if (!petData.selectedFlavours.includes(inputValue)) petData.selectedFlavours.push(inputValue);
    } else {
      const index = petData.selectedFlavours.indexOf(inputValue);
      if (index !== -1) petData.selectedFlavours.splice(index, 1);
    }
    console.log('selectedFlavours: ', petData.selectedFlavours);
    if(petId != 0){
    document.querySelector(`.flavours_update_${petId}`).innerHTML = petData.selectedFlavours;
    updatePetInputFields(petId, 'Flavors', JSON.stringify(petData.selectedFlavours))
    }
  } else if (itsType === 'toy') {
    if (isChecked) {
      if (!petData.selectedToys.includes(inputValue)) petData.selectedToys.push(inputValue);
    } else {
      const index = petData.selectedToys.indexOf(inputValue);
      if (index !== -1) petData.selectedToys.splice(index, 1);
    }
    console.log('selectedToys: ', petData.selectedToys);
    if(petId != 0){
    document.querySelector(`.toys_update_${petId}`).innerHTML = petData.selectedToys;
    updatePetInputFields(petId, 'toy', JSON.stringify(petData.selectedToys))
    }
  }
}

function renderSelectedConditions(selectedConditionsContainer, itsType, petId, isUpdate = true) {
  let selectedConditions;
  if (itsType == 'medical') {
    selectedConditionsContainer.innerHTML = '';
    selectedConditions = presentPetData[`petexist${petId}`].selectedMedicalConditions;
    if (isUpdate && petId != 0) updatePetInputFields(petId, 'medical', JSON.stringify(presentPetData[`petexist${petId}`].selectedMedicalConditions))
    selectedConditions.forEach(condition => {
      const selectedItem = document.createElement('div');
      selectedItem.classList.add('selected-condition');

      const conditionName = document.createElement('span');
      conditionName.textContent = condition;

      const removeBtn = document.createElement('button');
      removeBtn.textContent = 'X';
      removeBtn.classList.add('remove-btn');
      removeBtn.addEventListener('click', () => removeMedicalCondition(condition, selectedConditionsContainer, itsType, petId));

      selectedItem.appendChild(conditionName);
      selectedItem.appendChild(removeBtn);
      selectedConditionsContainer.appendChild(selectedItem);
    });
  }
  else if (itsType == 'allergy') {
    selectedConditions = presentPetData[`petexist${petId}`].selectedAllergies;
    if (isUpdate) updatePetInputFields(petId, 'allergies', JSON.stringify(presentPetData[`petexist${petId}`].selectedAllergies))
  }
  else if (itsType == 'flavours') {
    selectedConditions = presentPetData[`petexist${petId}`].selectedFlavours;
    if (isUpdate) updatePetInputFields(petId, 'Flavors', JSON.stringify(presentPetData[`petexist${petId}`].selectedFlavours))
  }
  else if (itsType == 'toys') {
    selectedConditions = presentPetData[`petexist${petId}`].selectedToys;
    if (isUpdate) updatePetInputFields(petId, 'toy', JSON.stringify(presentPetData[`petexist${petId}`].selectedToys))
  }
}

function removeMedicalCondition(condition, selectedConditionsContainer, itsType, petId) {
  if (itsType == 'medical') {
    presentPetData[`petexist${petId}`].selectedMedicalConditions = presentPetData[`petexist${petId}`].selectedMedicalConditions.filter(item => item !== condition);
    if(petId != 0)document.querySelector(`.medical_update_${petId}`).innerHTML = presentPetData[`petexist${petId}`].selectedMedicalConditions;
  } else if (itsType == 'allergy') {
    presentPetData[`petexist${petId}`].selectedAllergies = presentPetData[`petexist${petId}`].selectedAllergies.filter(item => item !== condition);
  } else if (itsType == 'flavours') {
    presentPetData[`petexist${petId}`].selectedFlavours = presentPetData[`petexist${petId}`].selectedFlavours.filter(item => item !== condition);
  } else if (itsType == 'toys') {
    presentPetData[`petexist${petId}`].selectedToys = presentPetData[`petexist${petId}`].selectedToys.filter(item => item !== condition);
  }
  renderSelectedConditions(selectedConditionsContainer, itsType, petId);
}

// 2nd time change in pet functionality of showing suggestions
function checkWhichRadioActive(input) {
  const parentForm = input.closest('form.pet-info-container');
  const radioContainer = parentForm?.querySelector('.species-container');
  const checkedRadio = radioContainer?.querySelector('input[type="radio"]:checked');
  if (checkedRadio) return (checkedRadio.value); else return ('Dog')
}

function changeInBreed(input, petId) {
  const radioValue = checkWhichRadioActive(input)
  const petBreed = radioValue === 'Dog' ? dogBreedData() : radioValue === 'Cat' ? catBreedData() : [];
  const searchTerm = input.value.toLowerCase()
  if (!searchTerm == '') {
    const matchingBreeds = petBreed.filter(breed => breed["Pet Breed"]?.toLowerCase().includes(searchTerm) || breed["Cat breeds complete"]?.toLowerCase().includes(searchTerm));
    showSuggestions(input, matchingBreeds, 'Pet Breed', searchTerm, petId);
  } else removeSuggestions(input)
}

function changeInMedican(input, id) {
  const radioValue = checkWhichRadioActive(input)
  const petMedicalCondition = radioValue === 'Dog' ? dogMedicalConditionData() : radioValue === 'Cat' ? catMedicalConditionData() : [];
  const searchTerm = input.value.toLowerCase()
  if (!searchTerm == '') {
    const matchingConditions = petMedicalCondition.filter(condition => condition["Conditions"]?.toLowerCase().includes(searchTerm));
    showSuggestionsAndValues(input, matchingConditions, 'Conditions', 'medical', searchTerm, id);
  } else removeSuggestions(input)
}

async function updatePetInputFields(petId, fieldId, currentValue) {
  if (petId == 0) return;
  const formData = new FormData();
  formData.append(fieldId, currentValue);
  formData.append('customer_id', customerId);
  formData.append('pet_id', petId);

  try {
    const response = await fetch(`https://nodejs.animeal.in/api/update-pet-profile?customer_id=${customerId}&pet_numb=${petId}`, {
      method: 'PATCH',
      body: formData
    });

    if (!response.ok) throw new Error('API Error');
    await response.json();
  } catch (error) {
    console.error('Error updating pet profile:', error);
    // alert('An error occurred while updating the pet profile.');
  }
}


function fillDataInPetFields() {
  document.querySelectorAll('.pet-suggestion-field').forEach(suggestedField => {
    const [petId, value] = suggestedField.getAttribute('data-id-value').split('-');
    const divContainer = suggestedField.querySelector('.selected-conditions');
    renderSelectedConditions(divContainer, value, petId, false);
  });
}


function updateToysOptions(speciesRadio) {
  const selectedSpecies = speciesRadio.value;
  const toysContainer = speciesRadio.closest('.pet-info-container').querySelector('.toys-container.pet-selected-values .selected-conditions');

  toysContainer.innerHTML = '';

  let toysList = [];

  const weightInput = speciesRadio.closest('.create-new-pet').querySelector('.pet-weight-radio-item input');
  console.log('weightInput:', weightInput);


  if(selectedSpecies === 'Dog' || selectedSpecies === 'Cat'){
    const allCatImages = document.querySelectorAll('.cat-weight-image')
    document.querySelectorAll('.dog-weight-image').forEach((singlImg, index) =>{
      singlImg.style.display = selectedSpecies === 'Dog' ? 'block': 'none';
      allCatImages[index].style.display = selectedSpecies === 'Dog' ? 'none' : 'block';
    })
    petNextBtn.style.display = 'block';
    petSubmitBtn.style.display = 'none';
    weightInput.required = true;
  }
  else{
    petNextBtn.style.display = 'none';
    petSubmitBtn.style.display = 'block';  
    weightInput.required = false;  
  }

  if (selectedSpecies === 'Dog') {
    toysList = getDogToys();
  } else if (selectedSpecies === 'Cat') {
    toysList = getCatToys();
  } else if (selectedSpecies === 'Farm Animals') {
    toysList = getFarmAnimalToys();
  } else if (selectedSpecies === 'Fish Reptile') {
    toysList = getFishReptileToys();
  } else if (selectedSpecies === 'Birds') {
    toysList = getBirdToys();
  }

  toysList.forEach(toy => {
    const label = document.createElement('label');
    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.name = 'toy';
    checkbox.value = toy.pet_toy;
    checkbox.onchange = function () {
      changeInMultiselectCheckbox(this);
    };

    const p = document.createElement('p');
    p.textContent = toy.pet_toy;

    label.appendChild(checkbox);
    label.appendChild(p);
    toysContainer.appendChild(label);
    toysContainer.appendChild(document.createElement('br'));
  });
}

// function vetSearchHelp(input) {
//   const query = input.value.toLowerCase();
//   const suggestionsBox = document.getElementById('vet-suggestions');
//   suggestionsBox.innerHTML = '';

//   if (query === '') return;

//   const vets = vetDataInformation();
//   const filtered = vets.filter(vet =>
//       vet["Vet Name"].toLowerCase().includes(query)
//   );
//   filtered.forEach(vet => {
//       const item = document.createElement('div');
//       item.className = 'vet-suggestion-item';
//       item.innerHTML = vet["Clinic Name"] ? `
//           <div class="vet-name">${vet["Vet Name"]}</div>
//           <div class="clinic-name">${vet["Clinic Name"] || '&nbsp;'}</div>`: `<div class="vet-name">${vet["Vet Name"]}</div>` ;
//       item.onclick = () => {
//         input.value = vet["Vet Name"] + (vet["Clinic Name"] ? ` (${vet["Clinic Name"]})` : '');
//         suggestionsBox.innerHTML = '';
//       };
//       suggestionsBox.appendChild(item);
//   });
// }

// function vetSearchHelp(input) {
//   const query = input.value.toLowerCase();
//   const suggestionsBox = document.getElementById('vet-suggestions');
//   suggestionsBox.innerHTML = '';

//   if (query === '') return;

//   const vets = vetDataInformation();

//   // Levenshtein Distance
//   function levenshtein(a, b) {
//     const matrix = Array.from({ length: b.length + 1 }, (_, i) => [i]);
//     matrix[0] = Array.from({ length: a.length + 1 }, (_, j) => j);

//     for (let i = 1; i <= b.length; i++) {
//       for (let j = 1; j <= a.length; j++) {
//         if (b.charAt(i - 1) === a.charAt(j - 1)) {
//           matrix[i][j] = matrix[i - 1][j - 1];
//         } else {
//           matrix[i][j] = Math.min(
//             matrix[i - 1][j] + 1,
//             matrix[i][j - 1] + 1,
//             matrix[i - 1][j - 1] + 1
//           );
//         }
//       }
//     }

//     return matrix[b.length][a.length];
//   }

//   function getSimilarity(a, b) {
//     const maxLen = Math.max(a.length, b.length);
//     if (maxLen === 0) return 1;
//     return (1 - levenshtein(a, b) / maxLen);
//   }

//   const threshold = 0.6;

//   const filtered = vets.filter(vet => {
//     const vetName = vet["Vet Name"].toLowerCase();
//     const clinicName = vet["Clinic Name"]?.toLowerCase() || '';
//     return (
//       vetName.includes(query) ||
//       clinicName.includes(query) ||
//       getSimilarity(vetName, query) >= threshold ||
//       getSimilarity(clinicName, query) >= threshold
//     );
//   });

//   filtered.forEach(vet => {
//     const item = document.createElement('div');
//     item.className = 'vet-suggestion-item';
//     item.innerHTML = vet["Clinic Name"] ? `
//         <div class="vet-name">${vet["Vet Name"]}</div>
//         <div class="clinic-name">${vet["Clinic Name"] || '&nbsp;'}</div>` :
//       `<div class="vet-name">${vet["Vet Name"]}</div>`;
//     item.onclick = () => {
//       input.value = vet["Vet Name"] + (vet["Clinic Name"] ? ` (${vet["Clinic Name"]})` : '');
//       suggestionsBox.innerHTML = '';
//     };
//     suggestionsBox.appendChild(item);
//   });
// }


let fetchedVetDirectory = [];
let vetDirectoryFetchPromise = null;

function loadVetDirectory() {
  if (!vetDirectoryFetchPromise) {
    vetDirectoryFetchPromise = fetch('https://nodejs.animeal.in/api/vet-directory')
      .then((res) => res.json())
      .then((data) => {
        fetchedVetDirectory = Array.isArray(data) ? data : [];
      })
      .catch((err) => {
        console.error('Failed to load vet directory:', err);
        fetchedVetDirectory = [];
      });
  }
  return vetDirectoryFetchPromise;
}

document.addEventListener('DOMContentLoaded', loadVetDirectory);

function vetSearchHelp(input) {
  const query = input.value.toLowerCase();
  const suggestionsBox = document.getElementById('vet-suggestions');
  suggestionsBox.innerHTML = '';

  if (query === '') return;

  loadVetDirectory().then(() => {
    if (input.value.toLowerCase() !== query) return; // stale keystroke, skip

    const vets = fetchedVetDirectory;

    function levenshtein(a, b) {
      const matrix = Array.from({ length: b.length + 1 }, (_, i) => [i]);
      matrix[0] = Array.from({ length: a.length + 1 }, (_, j) => j);
      for (let i = 1; i <= b.length; i++) {
        for (let j = 1; j <= a.length; j++) {
          matrix[i][j] = b.charAt(i - 1) === a.charAt(j - 1)
            ? matrix[i - 1][j - 1]
            : Math.min(matrix[i - 1][j] + 1, matrix[i][j - 1] + 1, matrix[i - 1][j - 1] + 1);
        }
      }
      return matrix[b.length][a.length];
    }

    function getSimilarity(a, b) {
      const maxLen = Math.max(a.length, b.length);
      return maxLen === 0 ? 1 : (1 - levenshtein(a, b) / maxLen);
    }

    const threshold = 0.6;
    const filtered = vets.filter(vet => {
      const vetName = vet["Vet Name"].toLowerCase();
      const clinicName = vet["Clinic Name"]?.toLowerCase() || '';
      return (
        vetName.includes(query) ||
        clinicName.includes(query) ||
        getSimilarity(vetName, query) >= threshold ||
        getSimilarity(clinicName, query) >= threshold
      );
    });

    filtered.forEach(vet => {
      const item = document.createElement('div');
      item.className = 'vet-suggestion-item';
      item.innerHTML = vet["Clinic Name"] ? `
          <div class="vet-name">${vet["Vet Name"]}</div>
          <div class="clinic-name">${vet["Clinic Name"] || '&nbsp;'}</div>` :
        `<div class="vet-name">${vet["Vet Name"]}</div>`;
      item.onclick = () => {
        input.value = vet["Vet Name"] + (vet["Clinic Name"] ? ` (${vet["Clinic Name"]})` : '');
        suggestionsBox.innerHTML = '';
      };
      suggestionsBox.appendChild(item);
    });
  });
}







// removed content for backup
// <div class="pet-name pet_edits__container">
/* {<h3 class="ptinfo_edit_label">Vet Name</h3>
<input type="text" class="ptinfo_edit_label_value" id="veterinarian_name" placeholder="Enter Your veterinarian Name" value="${pet.veterinarian_name || ''}" required>
</div> }*/